import militarySelectiveServiceValidator from 'forms/sections/military/selectiveService/validate';
import { validateModel } from 'models/validate';
import { getSafeDateTime } from 'helpers/date';

export const hideSelectiveService = (store = {}) => {
  const selectiveServiceDate = new Date(1959, 11, 31);
  const birthdate = store.Identification?.ApplicantBirthDate?.Date || {};
  const gender = store.Identification?.Physical?.Sex?.value;

  // Check the limits and gender
  return (
    getSafeDateTime(birthdate).datetime?.toJSDate() <= selectiveServiceDate || gender === 'Female'
  );
};

export const validateSelectiveService = (data, formType, options = {}) => validateModel(data, militarySelectiveServiceValidator, options);
